/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptions
 */
export interface FxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptions {
    /**
     * Ключ локализации для названия игры. 
     * Если указан (например "fxid_game_name"), то на фронте он будет 
     * развернут в "game_system_name.fxid_game_name"
     * @type {string}
     * @memberof FxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptions
     */
    GameName?: string | null;
}

/**
 * Check if a given object implements the FxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptions interface.
 */
export function instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptions(value: object): value is FxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptions {
    return true;
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptionsFromJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptions {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptionsFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'GameName': json['GameName'] == null ? undefined : json['GameName'],
    };
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptionsToJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptions {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptionsToJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptionsToJSONTyped(value?: FxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'GameName': value['GameName'],
    };
}

